import styled from 'styled-components'
import config from '../../config'

export const PageStyle = styled.div`
  background-image: url('${config.assets.gallerium}');
  background-size: cover;
  padding-top: 30px; // 30px notice bar
  height: 100vh;
  overflow: scroll;

  // layout -> content -> grid-container OR infinite-scroll-container
  .page-layout {
    height: 100%;
    display: grid;
    grid-template-columns: minmax(280px, 25%) 1fr;
  }

  .page-content {
    backdrop-filter: blur(15px);
    background-color: rgba(255, 255, 255, 0.2);
    display: grid;
    grid-template-rows: 80px 1fr; // 80px header
    /* padding-right: 65px; // right navbar */

    .grid-container {
      display: grid;
      grid-gap: 40px;
      grid-template-columns: repeat(auto-fill, 200px);
      margin: 20px 80px;
      grid-auto-rows: max-content;
    }

    // header
    .back-btn {
      background: #394554;
      font-weight: bold;
      color: #FFD200;
      display: flex;
      align-items: center;
      text-decoration: none;
      padding: 20px 30px;
      .back-icon {
        cursor: pointer;
        display: flex;
        width: 30px;
        flex-direction: column;
        img,
        svg {
          transition: 100ms linear;
          height: 24px;
        }
        .icon-label {
          transition: 100ms linear;
          text-align: left;
          font-size: 1px;
          opacity: 0;
        }
        &:hover {
          img,
          svg {
            transform: scale(0.5);
          }
          .icon-label {
            font-size: 8px;
            opacity: 1;
          }
        }
      }
      span {
        font-size: 24px;
        font-style: italic;
        margin-left: 1em;
        color: #FFD200;
      }
    }
  }

  .page-sidebar {
    color: white;
    font-size: 20px;
    padding: 0 30px;
    position: relative;
    .page-title {
      width: 100%;
      position: sticky;
      top: 40%;
      h2 {
        text-align: center;
        font-weight: 600;
        font-size: 30px;
      }
    }
  }
  .card-thumbnail {
    display: block;
    cursor: pointer;
    position: relative;
    text-align: center;
    color: white;
    font-weight: 600;
    text-decoration: none;
    font-size: 18px;
    img {
      transition: 150ms ease-in;
    }
    h6 {
      font-size: 80%;
      margin: 0;
      margin-top: 8px;
    }
    &:hover {
      img {
        transform: scale(1.1);
      }
    }
  }
`
